/**
 * return array of css class
 * @param {array|string} sourceClass
 * @param staticClass
 * @param className
 * @return {[*[], *, *]}
 */
export default (sourceClass = [], { staticClass, class: className }) => [
    sourceClass,
    staticClass,
    className,
];
